import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
import type { VehicleTemplateType } from '@/features/vehicleTemplate/domain/enums/VehicleTemplateType'
import type { VehicleTemplateEntity } from '@/features/vehicleTemplate/domain/entities/VehicleTemplateEntity'
import type { DriverTeamEntity } from '@/features/driverTeam/domain/entities/DriverTeamEntity'
import type { DriverStatus } from '../enums/DriverStatus'
import type { DriverEntity } from './DriverEntity'
import type { DriverOrderSupportType } from '../enums/DriverOrderSupportType'
export class DriverFilterEntity {
  id?: number
  driver?: DriverEntity
  user?: UserMiniEntity
  fullName?: string
  workingPhoneNumber?: string
  orderSupportType?: DriverOrderSupportType
  region?: RegionMiniEntity
  page?: number
  searchWord?: string
  limit?: number
  status?: DriverStatus
  vehicleTemplateType?: VehicleTemplateType
  canHandleSensitiveOrders?: boolean
  vehicleTemplate?: VehicleTemplateEntity
  driverTeam?: DriverTeamEntity
  date?: string[]
  isBlocked?: boolean
  regionIds?: number[]
}
